import React from 'react';

const ManageVendorConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/teamlead/managevendor',
            component: React.lazy(() => import('./manageVendor.js'))
        }
    ]
};

export default ManageVendorConfig;